import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/common/ErrorBoundary';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Registers the service worker in production only (see service-worker.js) so
// the app is installable to a home screen/desktop and keeps working offline
// for its own shell. Deliberately never caches API responses, so this has no
// effect on auth/session behavior — that's controlled entirely by the
// session cookie's Max-Age (already persistent by default, see auth.py).
serviceWorkerRegistration.register();
